<template>
	<div>
		<div class="stage">
			<div class="row margin-b20">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<div class="backBtn mobileMargin-b15">
						<router-link to="/resellers"
							><p
								class="textUppercase textGrey textXsml fontHeavy hover:text-[#555555] dark:hover:text-[#eeeeee]"
							>
								<span class="fa-light fa-arrow-left textGrey"></span> Take me back
							</p></router-link
						>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<ul class="stepBtnsRight">
						<li>
							<button
								:disabled="!editReseller.companyName || loading"
								class="jmiBtn btnLg green"
								@click="save()"
							>
								{{ editReseller.id ? 'Save' : 'Create' }}
							</button>
						</li>
						<li><button class="jmiBtn btnLg red" @click="routeTo('/resellers')">Close</button></li>
					</ul>
				</div>
			</div>
			<div class="row margin-b10">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-lg-offset-3">
					<div class="row margin-b10">
						<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
							<!-- <p class="textSml textGrey fontHeavy textUppercase">User</p> -->
						</div>
					</div>
					<div class="row margin-b20">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div class="card detailCard flex flex-col rounded-sm shadow-lg">
								<div class="mx-auto mb-5 w-full">
									<div class="col-sm-12 textCenter">
										<div class="navAvatar margin-b10 flex w-full justify-center">
											<img src="/assets/images/teleflow-logo-black.png" width="200" />
										</div>
									</div>
								</div>
								<div v-if="!loading">
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Personal Information</h3>
									</div>
									<div class="mx-auto mb-2 flex w-full flex-row flex-wrap md:mb-5">
										<div class="w-1/2 px-2">
											<div class="formGroup">
												<label class="textGrey">Company Name</label>
												<FormKit
													v-model="editReseller.companyName"
													type="text"
													class="form-control"
													required
													placeholder="Company Name"
													name="Company Name"
													:validation="'required'"
													validation-visibility="live"
												/>
											</div>
										</div>
										<div class="w-1/2 px-2">
											<div class="formGroup">
												<label class="textGrey">Contact Name</label>
												<input
													v-model="editReseller.contactName"
													type="text"
													class="form-control"
													placeholder="Contact Name"
												/>
											</div>
										</div>
									</div>
									<div class="mb-2 w-full px-2 md:mb-5">
										<div class="formGroup">
											<label class="textGrey">Email</label>
											<input
												v-model="editReseller.email"
												type="email"
												class="form-control"
												placeholder="Email"
											/>
										</div>
									</div>
									<div class="mx-auto mb-2 flex w-full flex-col md:mb-5 md:flex-row">
										<div class="w-full px-2 md:w-1/2">
											<div class="formGroup">
												<label class="textGrey">Phone</label>
												<input
													v-model="editReseller.phone"
													type="text"
													class="form-control"
													placeholder="Phone"
												/>
											</div>
										</div>
										<div class="w-full px-2 md:w-1/2">
											<div class="formGroup">
												<label class="textGrey">Default Network Number</label>
												<input
													v-model="editReseller.default_network_number"
													type="text"
													class="form-control"
													placeholder="Default Network Number"
												/>
											</div>
										</div>
									</div>
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Number Porting</h3>
									</div>
									<div class="mx-auto mb-2 flex w-full flex-row flex-wrap md:mb-5">
										<div class="w-1/2 px-2">
											<div class="formGroup">
												<label class="textGrey">Porting Email</label>
												<FormKit
													v-model="editReseller.portingEmail"
													type="text"
													class="form-control"
													placeholder="Porting Email"
													name="Porting Email"
												/>
											</div>
										</div>
										<div class="w-1/2 px-2">
											<div class="formGroup withIcon">
												<label class="textGrey">Porting LOA Preference</label>
												<select
													v-model="editReseller.portingLOAPreference"
													class="form-control"
												>
													<option :value="null">Never</option>
													<option value="nongeo">Non-Geo only</option>
													<option value="always">Always</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
									</div>
									<div class="margin-b20 mt-12 flex px-2">
										<div class="col-md-12">
											<ul class="stepBtns">
												<li>
													<button
														:disabled="!editReseller.companyName || loading"
														class="jmiBtn btnLg green"
														@click="save()"
													>
														{{ editReseller.id ? 'Save' : 'Create' }}
													</button>
												</li>
												<li>
													<button class="jmiBtn btnLg red" @click="routeTo('/resellers')">
														Close
													</button>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div v-else>
									<div class="row margin-b20 center-xs center-md center-lg">
										<div class="loader"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import resellersApi from '../scripts/resellers/resellers.api.js'
import { router } from '../router'

export default {
	inject: ['user', 'userRoles'],
	data() {
		return {
			editReseller: {
				companyName: '',
				contactName: '',
				email: '',
				phone: '',
				default_network_number: '',
				portingEmail: '',
				portingLOAPreference: null
			},
			loading: true
		}
	},

	async created() {
		try {
			if (this.$route.params.id !== 'new') {
				const result = await resellersApi.getById(this.$route.params.id)
				this.editReseller = result.data
			}
			this.loading = false
		} catch (e) {
			this.$swal({
				title: 'Error loading reseller',
				icon: 'error',
				confirmButtonText: 'Confirm',
				text: 'Unknown error occurred, please try again. If the issue persists, please raise a support ticket.'
			}).then(() => {
				router.push('/resellers')
			})
			console.error(e)
		}
	},

	methods: {
		routeTo(routeName) {
			router.push(routeName)
		},
		save() {
			if (!this.editReseller.id) {
				resellersApi
					.create(this.editReseller)
					.then((res) => {
						this.routeTo('/resellers')
					})
					.catch(console.error)
			} else {
				resellersApi
					.update(this.editReseller)
					.then((res) => {
						this.routeTo('/resellers')
					})
					.catch(console.error)
			}
		}
	}
}
</script>
